<template>
  <div class="bodyclass">
    <!--首页大框-->
    <!-- :class="{ 'banner-in': shouldApplyEffects }" -->
    <div :class="'top-box pz_banner' + showStateNum"  ref="targetTopRef">
      <!--菜单-->
      <div class="top-menu">
        <div class="top-menu-t clearfloat">
          <div class="menu-logo fl"></div>
          <div class="menu-txt fl"  >
            <ul class="li-div-txt"  >
              <!-- v-show="showMenuStateSy" @mouseenter="handleEnter('sy')" @mouseleave="handleLeave()" -->
              <li><a class="dbi fb w100 menu-atxt txtsh"  href="/">首页</a></li>
              <li> <a class="dbi fb w100 menu-atxt txtsh"  href="/chanping1">产品</a>
                <!-- style="width:1000px;" WOW animate__animated animate__fadeOut animation-delay: 0.3s;-->
                <div class="li-div  " style="width:1000px;"  >
                  <div class="li-div-left fl"> <span class="tl dbi">产品</span> </div>
                  <div class="w68 fl">
                    <ul class="li-div-txt">
                      <li class="" style="width:23%"> 
                        <a class="dbi  w100 menu-atxt" href="/chanping4">
                          <div class="li-div-d2 mt10 "> 
                            <img src="../assets/images/z13-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">视觉智能体</h1>
                        </a> 
                      </li>
                      <li style="width:23%"> 
                        <a class="dbi w100 menu-atxt" href="/chanping3">
                          <div class="li-div-d2 mt10"> 
                            <img src="../assets/images/z12-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">新一代公共安全视觉智能体</h1>
                        </a> 
                      </li>
                      <li class="" style="width:23%"> 
                        <a class="dbi w100 menu-atxt" href="/chanping1">
                          <div class="li-div-d2 mt10"> 
                            <img src="../assets/images/z1-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                        </a> 
                      </li>
                      <li style="width:23%"> 
                        <a class="dbi  w100 menu-atxt" href="/chanping2">
                          <div class="li-div-d2 mt10 "> 
                            <img src="../assets/images/z2-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh40">视觉大模型一体机</h1>
                        </a> 
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li >
                <!-- class="WOW animate__animated animate__fadeInRight animate__duration-5s" -->
                <a class="dbi fb w100 menu-atxt txtsh" href="/jiejfa1">解决方案</a>
                <div class="li-div" style="width:1300px;">
                  <div class="li-div-left fl" style="width:220px"> <span class="tl dbi">解决方案</span> </div>
                  <div class="w70 fl" style="height:148px;">
                    <ul class="">
                      <li> <a class="dbi  w100 menu-atxt" href="/jiejfa1">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z3-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40 ">公共安全行业解决方案</h1>
                        </a> </li>
                      <li> <a class="dbi  w100 menu-atxt" href="/yijii2">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z4-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">应急行业解决方案</h1>
                        </a> </li>
                      <li> <a class="dbi  w100 menu-atxt" href="/chengguan3">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z5-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">城管行业解决方案</h1>
                        </a> </li>
                      <li> <a class="dbi  w100 menu-atxt" href="/jiaotong4">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z6-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">交通行业解决方案</h1>
                        </a> </li>
                      <li> <a class="dbi  w100 menu-atxt" href="/qiyeigl5">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z7-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">企业管理解决方案</h1>
                        </a> </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li><a class="dbi fb w100 menu-atxt txtsh" href="/severHtml">服务&生态</a></li>
              <li><a class="dbi fb w100 menu-atxt txtsh" href="/gywmHtml">关于我们</a></li>
            </ul>
          </div>
        </div>
      </div>
      <!--菜单end-->
      <!--背景滚动钮-->
      <div class="annui">
        <div class="annui-l" @click="() => addAndDelFunc('del')">
          <a class="dbi wi50 he50 mt30 ml30">
            <i class="fa fa-angle-double-left f40 white wi50 he50"></i>
          </a>
        </div>
        <div class="annui-r" @click="() => addAndDelFunc('add')">
          <a class="dbi wi50 he50 mt30 ml30">
            <i class="fa fa-angle-double-right f40 white wi50 he50"></i>
          </a>
        </div>
        <div class="annui-b tc">
          <a class="dbi wi20 he20 tc" @click="checkMunFunc(1)">
            <i :class="'fa f15 wi20 white he20' + (showChangeDpCheck == 1 ? ' fa-dot-circle-o' : ' fa-circle-o')"></i>
          </a>
          <a class="dbi wi20 he20 tc" @click="checkMunFunc(2)">
            <i
              :class="'fa f15 wi20 white he20 ml5' + (showChangeDpCheck == 2 ? ' fa-dot-circle-o' : ' fa-circle-o')"></i>
          </a>
          <a class="dbi wi20 he20 tc" @click="checkMunFunc(3)">
            <i
              :class="'fa f15 wi20 white he20 ml5' + (showChangeDpCheck == 3 ? ' fa-dot-circle-o' : ' fa-circle-o')"></i>
          </a>
          <a class="dbi wi20 he20 tc" @click="checkMunFunc(4)">
            <i
              :class="'fa f15 wi20 white he20 ml5' + (showChangeDpCheck == 4 ? ' fa-dot-circle-o' : ' fa-circle-o')"></i>
          </a>
          <a class="dbi wi20 he20 tc" @click="checkMunFunc(5)">
            <i
              :class="'fa f15 wi20 white he20 ml5' + (showChangeDpCheck == 5 ? ' fa-dot-circle-o' : ' fa-circle-o')"></i>
          </a>
          <a class="dbi wi20 he20 tc" @click="checkMunFunc(6)">
            <i
              :class="'fa f15 wi20 white he20 ml5' + (showChangeDpCheck == 6 ? ' fa-dot-circle-o' : ' fa-circle-o')"></i>
          </a>
        </div>
        <div class="annui-t tc">
          <a class="dbi wi40 he40 tc anim">
            <i class="fa fa-angle-double-down f28 wi20 white he20"></i>
          </a>
        </div>
      </div>
      <!--背景滚动钮end-->
      <!--文字-->
      <div class="big-txt" v-show="showChangeDpCheck == 1">
        <div class="gig-txt-a tc">
          <div class="dbi">
            <h3 class="f50 wow animate__animated animate__fadeInDown  "
              style="animation-delay: 0.1s;" >谛视万象</h3>
            <h4 class="mt20 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">谛观万象 智视未来</h4>
            <p class="mt30 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.5s;">谛视万象多模态视觉大模型</p>
          </div>
        </div>
      </div>
      <!--文字eend-->
       <!--文字-->
      <div class="big-txt" v-show="showChangeDpCheck == 2">
        <div class="gig-txt-a tc">
          <div class="dbi">
            <h3 class="f50 wow animate__animated animate__fadeInDown  "
              style="animation-delay: 0.1s;">分钟级算法创建</h3>
            <h4 class="mt20 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">小时级部署上线</h4>
            <p class="mt30 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.5s;">从算法创建完成到上线使用仅需小时级时间</p>
          </div>
        </div>
      </div>
      <!--文字eend-->
       <!--文字-->
      <div class="big-txt" v-show="showChangeDpCheck == 3">
        <div class="gig-txt-a tc">
          <div class="dbi">
            <h3 class="f50 wow animate__animated animate__fadeInDown  "
              style="animation-delay: 0.1s;">视觉智能分析基座</h3>
            <h4 class="mt20 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">以视觉感知能力为核心</h4>
            <p class="mt30 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">助力各行业智能化升级与跨越式发展</p>
          </div>
        </div>
      </div>
      <!--文字end-->
      <!--文字-->
      <div class="big-txt" v-show="showChangeDpCheck == 4">
        <div class="gig-txt-a tc">
          <div class="dbi">
            <h3 class="f50 wow animate__animated animate__fadeInDown  "
              style="animation-delay: 0.1s;">视觉大模型一体机</h3>
            <h4 class="mt20 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">一站式智能设备</h4>
            <p class="mt30 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">人工智能视觉大模型平台与高性能计算硬件的一站式智能设备</p>
          </div>
        </div>
      </div>
      <!--文字end-->
      <!--文字-->
      <div class="big-txt" v-show="showChangeDpCheck == 5">
        <div class="gig-txt-a tc">
          <div class="dbi">
            <h3 class="f50 wow animate__animated animate__fadeInDown  "
              style="animation-delay: 0.1s;">新一代公共安全视觉智能体</h3>
            <h4 class="mt20 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">自主安防感知与决策智能体</h4>
            <p class="mt30 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">融合多种智能终端，实时感知、分析、预警</p>
          </div>
        </div>
      </div>
      <!--文字end-->
      <!--文字-->
      <div class="big-txt" v-show="showChangeDpCheck == 6">
        <div class="gig-txt-a tc">
          <div class="dbi">
            <h3 class="f50 wow animate__animated animate__fadeInDown  "
              style="animation-delay: 0.1s;">视觉智能体</h3>
            <h4 class="mt20 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">融合视觉大模型与智能体技术</h4>
            <p class="mt30 wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;">视觉感知动态环境精准视觉分析服务</p>
          </div>
        </div>
      </div>
      <!--文字end-->
      <!--背景图-->
      <!-- 
      <div class="frame">
        <div class="child" style="background-image: url(&quot;images/bana-1.jpg&quot;); transform: scale(0.7, 0.7); opacity: 0; z-index: -1;"></div>
        <div class="child" style="background-image: url(&quot;images/bana-2.jpg&quot;); transform: scale(0.7, 0.7); opacity: 0; z-index: -1;"></div>
        <div class="child" style="background-image: url(&quot;images/bana-3.jpg&quot;); transform: scale(0.7, 0.7); opacity: 0; z-index: -1;"></div>
        <div class="child" style="background-image: url(&quot;images/bana-4.jpg&quot;); transform: scale(0.7, 0.7); opacity: 0; z-index: -1;"></div>
        <div class="child" style="background-image: url(&quot;images/bana-14.jpg&quot;); transform: scale(0.7, 0.7); opacity: 0; z-index: -1;"></div>
        <div class="child" style="background-image: url(&quot;images/bana-15.jpg&quot;); transform: scale(0.7, 0.7); opacity: 0; z-index: -1;"></div>
        
      </div>
       -->
      <!-- showChangeDpCheck -->
      <!-- style="transform: scale(1.1, 1.1); opacity: 1; z-index: 0; transition: transform 7000ms;" -->
      <!-- v-show="showChangeDpCheck == 1" -->
      <!-- v-show="showChangeDpCheck == 2" -->
      <!-- v-show="showChangeDpCheck == 3" -->
      <!-- v-show="showChangeDpCheck == 4" -->
      <!-- v-show="showChangeDpCheck == 5" -->
      <!-- v-show="showChangeDpCheck == 6" -->
      <!-- </transition> -->
      <div class="top-backgr bg-zoom-container">
        <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
          <div class="top-backgr-img bg-animated backImg1" v-show="showChangeDpCheck == 1"></div>
        </transition>
        <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
          <div class="top-backgr-img bg-animated backImg2" v-show="showChangeDpCheck == 2"></div>
        </transition>
        <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
          <div class="top-backgr-img bg-animated backImg3" v-show="showChangeDpCheck == 3"></div>
        </transition>
        <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
          <div class="top-backgr-img bg-animated backImg4" v-show="showChangeDpCheck == 4"></div>
        </transition>
        <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
          <div class="top-backgr-img bg-animated backImg5" v-show="showChangeDpCheck == 5"></div>
        </transition>
        <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
          <div class="top-backgr-img bg-animated backImg6" v-show="showChangeDpCheck == 6"></div>
        </transition>
      </div>

      <!--背景图end-->

      <!--首页大框end-->
    </div>
    <!--首页大框-->
    <!--内容大框-->
    <div class="main pt84 " ref="targetRef">
      <!--菜单-->
      <!-- v-if="topMenuShow" :v-show="false" visible-menu -->
      <div class="main-menu tc " v-if="topMenuShow" style="">
        <ul class="main-m-a1 dbi ">
          <li><a href="/" class="txt-2">首页</a></li>
          <li>
            <a href="/chanping1" class="txt-2">产品</a>
            <div class="li-div" style="width:1000px;top:140px;">
              <div class="li-div-left fl"> 
                <span class="tl dbi">产品</span> 
              </div>
              <div class="w60 fl">
                <ul class="">
                  <li class="" style="width:23%"> 
                    <a class="dbi  w100 menu-atxt21" href="/chanping4">
                      <div class="li-div-d2 mt10 "> 
                        <img src="../assets/images/z13-ytj.png" class="li-div-img">
                      </div>
                      <h1 class="f16 lh40 white">视觉智能体</h1>
                    </a> 
                  </li>
                  <li class="" style="width:23%"> 
                    <a class="dbi  w100 menu-atxt21" href="/chanping3">
                      <div class="li-div-d2 mt10 "> 
                        <img src="../assets/images/z12-ytj.png" class="li-div-img">
                      </div>
                      <h1 class="f16 lh20 white">新一代公共安全视觉智能体</h1>
                    </a> 
                  </li>
                  <li class="" style="width:23%"> 
                    <a class="dbi  w100 menu-atxt21" href="/chanping1">
                      <div class="li-div-d2 mt10 "> 
                        <img src="../assets/images/z1-ytj.png" class="li-div-img">
                      </div>
                      <h1 class="f16 lh40 white">视觉大模型平台</h1>
                    </a> 
                  </li>
                  <li style="width:23%"> 
                    <a class="dbi  w100 menu-atxt21" href="/chanping2">
                      <div class="li-div-d2 mt10 "> 
                        <img src="../assets/images/z2-ytj.png" class="li-div-img">
                      </div>
                      <h1 class="f16 lh40 white">视觉大模型一体机</h1>
                    </a> 
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- class="WOW wow animate__animated animate__fadeInUp animate__duration-5s" -->
          <li>
            <a href="/jiejfa1" class="">解决方案</a>
            <div class="li-div" style="width:1300px;top:140px">
              <div class="li-div-left fl" style="width:220px"> <span class="tl dbi">解决方案</span> </div>
              <div class="w70 fl" style="height:148px;">
                <ul class="">
                  <li> <a class="dbi  w100 menu-atxt21" href="/jiejfa1">
                      <div class="li-div-d2 mt10 "> <img src="../assets/images/z3-ytj.png" class="li-div-img"></div>
                      <h1 class="f16 lh40 white">公共安全行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt21" href="/yijii2">
                      <div class="li-div-d2 mt10 "> <img src="../assets/images/z4-ytj.png" class="li-div-img"></div>
                      <h1 class="f16 lh40 white">应急行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt21" href="/chengguan3">
                      <div class="li-div-d2 mt10 "> <img src="../assets/images/z5-ytj.png" class="li-div-img"></div>
                      <h1 class="f16 lh40 white">城管行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt21" href="/jiaotong4">
                      <div class="li-div-d2 mt10 "> <img src="../assets/images/z6-ytj.png" class="li-div-img"></div>
                      <h1 class="f16 lh40 white">交通行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt21" href="/qiyeigl5">
                      <div class="li-div-d2 mt10 "> <img src="../assets/images/z7-ytj.png" class="li-div-img"></div>
                      <h1 class="f16 lh40 white">企业管理解决方案</h1>
                    </a> </li>
                </ul>
              </div>
            </div>
          </li>
          <li><a href="/severHtml" class="">服务&生态</a></li>
          <li><a href="/gywmHtml" class="">关于我们</a></li>
        </ul>
      </div>
      <!--菜单end-->
      <!--解决方案-->
      <!-- class="WOW wow animate__animated animate__fadeInUp animate__duration-5s " -->
      <div class="w100 mt100 lh40 tc WOW wow animate__animated animate__fadeInUp animate__duration-1s">
        <span class="db f48 fb lp2 mt40">解决方案</span>
        <span class="db f24  lp2 mt20 col-gr">Solution</span>
      </div>
      <div class="mt240 jjfa">
        <div class="jjfa-block">
          <ul>
            <li @mouseenter="() => mouseenterFunc(1)" class=" wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.3s;"> <a class="dbi" href="/jiejfa1">
                <div class="tc"><img src="../assets/images/z3-ytj.png" width="120" alt="" class="mt30" /></div>
                <div class="tc white f18 mt10">公共安全行业解决方案</div>
                <div class="tc white f12 col-gr1 mt6">PUBLIC SECURITY INDUSTRY</div>
              </a> </li>
            <li @mouseenter="() => mouseenterFunc(2)" class=" wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.5s;"> <a class="dbi" href="/yijii2">
                <div class="tc"><img src="../assets/images/z4-ytj.png" width="120" alt="" class="mt30" /></div>
                <div class="tc white f18 mt10">应急行业解决方案</div>
                <div class="tc white f12 col-gr1 mt6">EMERGENCY INDUSTRY</div>
              </a> </li>
            <li @mouseenter="() => mouseenterFunc(3)" class=" wow animate__animated animate__fadeInUp  "
              style="animation-delay: 0.7s;"> <a class="dbi" href="/chengguan3">
                <div class="tc"><img src="../assets/images/z5-ytj.png" width="120" alt="" class="mt30" /></div>
                <div class="tc white f18 mt10">城管行业解决方案</div>
                <div class="tc white f12 col-gr1 mt6">URBAN MANAGEMENT INDUSTRY</div>
              </a> </li>
            <li @mouseenter="() => mouseenterFunc(4)" class=" wow animate__animated animate__fadeInUp a "
              style="animation-delay: 0.9s;"> <a class="dbi" href="/jiaotong4">
                <div class="tc"><img src="../assets/images/z6-ytj.png" width="120" alt="" class="mt30" /></div>
                <div class="tc white f18 mt10">交通行业解决方案</div>
                <div class="tc white f12 col-gr1 mt6">TRANSPORTATION INDUSTRY</div>
              </a> </li>
            <li @mouseenter="() => mouseenterFunc(5)" class=" wow animate__animated animate__fadeInUp  "
              style="animation-delay: 1.1s;"> <a class="dbi" href="/qiyeigl5">
                <div class="tc"><img src="../assets/images/z7-ytj.png" width="120" alt="" class="mt30" /></div>
                <div class="tc white f18 mt10">企业管理解决方案</div>
                <div class="tc white f12 col-gr1 mt6">BUSINESS MANAGEMENT</div>
              </a> </li>
          </ul>
        </div>
        <!-- v-if="mouseenterCheck == 1" -->
        <div class="jjfa-img tc backy-b-1 wow animate__animated animate__fadeInUp" v-if="mouseenterCheck == 0">
          <p class="mt200 fb white lp2 f30 txtsh">包括但不限于人员身份及轨迹识别<br />
            行为特征识别、场景事件识别</p>
          <a class="dbi jjfa-a mt50" href="/jiejfa1">了解方案详情</a>
        </div>
        <div class="jjfa-img tc backy-b-1 wow animate__animated animate__fadeIn" v-if="mouseenterCheck == 1">
          <p class="mt200 fb white lp2 f30 txtsh">包括但不限于人员身份及轨迹识别<br />
            行为特征识别、场景事件识别</p>
          <a class="dbi jjfa-a mt50" href="/jiejfa1">了解方案详情</a>
        </div>
        <div class="jjfa-img tc backy-b-2 wow animate__animated animate__fadeIn" v-if="mouseenterCheck == 2">
          <p class="mt200 fb white lp2 f30 txtsh">灾害监控预警、人员危险识别<br />
            根据应急行业实际业务需要确定需要监测的场景</p>
          <a class="dbi jjfa-a mt50" href="/yijii2">了解方案详情</a>
        </div>
        <div class="jjfa-img tc backy-b-3 wow animate__animated animate__fadeIn" v-if="mouseenterCheck == 3">
          <p class="mt200 fb white lp2 f30 txtsh">公共设施管理、环境治理<br />
            根据城管行业实际业务需要确定需要监测的场景</p>
          <a class="dbi jjfa-a mt50" href="/chengguan3">了解方案详情</a>
        </div>
        <div class="jjfa-img tc backy-b-4 wow animate__animated animate__fadeIn" v-if="mouseenterCheck == 4">
          <p class="mt200 fb white lp2 f30 txtsh">路面识别、车内人员状态<br />
            根据交通行业实际业务需要确定需要监测的场景</p>
          <a class="dbi jjfa-a mt50" href="/jiaotong4">了解方案详情</a>
        </div>
        <div class="jjfa-img tc backy-b-5 wow animate__animated animate__fadeIn" v-if="mouseenterCheck == 5">
          <p class="mt200 fb white lp2 f30 txtsh">设备识别，人员状态<br />
            根据企业行业实际业务需要确定需要监测的场景</p>
          <a class="dbi jjfa-a mt50" href="/qiyeigl5">了解方案详情</a>
        </div>
      </div>
      <!--解决方案end-->
      <!--应用场景展示-->
      <div class="yycj mt60">
        <div class="w70 clearfloat jz WOW animate__animated animate__fadeInRight animate__duration-5s"
          style="animation-delay: 1.2s;">
          <!-- wow animate__animated animate__fadeInRight -->
          <div class="w40 fl mt120 tl">
            <div><a class="db tl white lp2 f24">谛视万象 MixZero具身智能体平台</a></div>
            <div class="f16 white mt40"> 智能安防无人巡控方案</div>
            <div class="f24 white mt40"><a class="dbi">以视觉智能为底座，让机器看懂世界、即刻行动</a></div>
            <div class="mt40 col-gr1 lp1 lh24">
              新一代智能无人安防无人车，由谛视万象MixZero具身智能本体平台深度赋能，联合新石器无人车底盘与江铃改装专业车辆制造能力，打造新一代AI无人安防巡逻解决方案。<br>在火车站安保实战中，MixZero作为"机器控制大脑"，将视觉大模型对开放世界的理解力，实时转化为设备的精准行动力。
            </div>
          </div>
          <div class="fl w45 mt110 ml60" data-wow-delay="0.2s">
              <!--  <img src="../assets/images/bg5.jpg" width="100%" height="100%" alt="" /> -->
              <!--  muted 视频静音 -->
            <video width="100%" height="" class="imgf" autoplay loop controls muted> 视频文件路径
              <source src="../assets/images/minzero.mp4" type="video/mp4">
              可以添加多个
              <source>
              标签来提供不同格式的视频文件，以兼容不同的浏览器
              <!-- <source src="your-video-file.ogg" type="video/ogg"> -->
              抱歉，你的浏览器不支持HTML5视频。
            </video>
          </div>
        </div>
      </div>
      <!--应用场景展示end-->
      <!--产品-->
      <div class="w100 lh40 tc mt70 WOW animate__animated animate__fadeInUp ">
        <span class="db f48 fb lp2 mt40">产品</span>
        <span class="db f24  lp2 mt20 col-gr">PRODUCT</span>
      </div>
      <div class="produ jz mt30">
          <!-- fadeInUp fadeInDown data-wow-duration="1s" -->
          <div class="fl produ-da4 tc WOW animate__animated animate__fadeInDown  " >
            <p class="mt100 fb white lp2 f34 txtsh">谛视万象视觉智能体</p>
            <a class="dbi produ-a mt50" href="/chanping4">了解产品详情</a>
          </div>
          <div class="fr produ-da1 tc WOW animate__animated animate__fadeInUp">
            <p class="mt100 fb white lp2 f34 txtsh">谛视万象多模态视觉大模型</p>
            <a class="dbi produ-a mt50" href="/chanping1">了解产品详情</a>
          </div>
          <div class="fl produ-da3 tc mt30 WOW animate__animated animate__fadeInUp">
            <p class="mt100 fb white lp2 f34 txtsh">新一代公共安全视觉智能体</p>
            <a class="dbi produ-a mt50" href="/chanping3">了解产品详情</a>
          </div>
          <!-- fadeInUp fadeInDown data-wow-duration="1s" -->
          <div class="fr produ-da2 tc mt30 WOW animate__animated animate__fadeInDown  " >
            <p class="mt100 fb white lp2 f34 txtsh">视觉大模型一体机</p>
            <a class="dbi produ-a mt50" href="/chanping2">了解产品详情</a>
          </div>
          
          
      </div>
      <!--产品end-->
      <!--合作伙伴-->
      <div class="w100 lh40 tc mt70">
        <span class="db f48 fb lp2 mt140">合作伙伴</span>
        <span class="db f24  lp2 mt20 col-gr">PARTNERS CUSTOMERS</span>
      </div>
      <div class="w100 mt100">
        <div class="hzhb jz">
          <div class="hzhb-b">
            <div class="hzhb-c">
              <span class="db tc f24">合作伙伴/客户</span>
              <span class="db tc f20">partner</span>
            </div>
          </div>
          <div class="hzhb-a"></div>
        </div>
      </div>
      <!--合作伙伴end-->
      <!-- <div v-wow="'fadeInUp'" data-wow-duration="1s" data-wow-delay="0.3s">...</div -->
      
    </div>
    <!--内容大框end-->
    <!--底宣-->
    <div class="btto-a1 mt100 ov">
      <div class="btto-a2 jz mt30">
        <ul class="w100 he68">
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;">
            <div class="btt-ico fl ">
              <img src="../assets/images/za1-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">全场景算法</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">algorithm</span>
              </div>
              <div class="mt4 col-gr3">多种行业全场景算法</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.3s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za2-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">算法灵活自定义</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Custom</span>
              </div>
              <div class="mt4 col-gr3">可通过文字自定义描述方式新增修改</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.5s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za3-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">国产化生态支持</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">support</span>
              </div>
              <div class="mt4 col-gr3">基于自主可控的国产化IT底层架构</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.7s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za4-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">完善标准化</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">standardization</span>
              </div>
              <div class="mt4 col-gr3">支持主流音视频标准化协议</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.9s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za5-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">大模型技术</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Large Model</span>
              </div>
              <div class="mt4 col-gr3">使用Transformer架构</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--底宣end-->
    <!--底宣2-->
    <div class="btto-b-a1 ov">
      <div class="mt30 w100 jz dbi">
        <div class="tc WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;"> <img src="../assets/images/ying-28.jpg" width="76" height="76" alt="" class="  dbi " /></div>
        <ul class="w100 he92 tc mt20">
          <li class=" WOW animate__animated animate__fadeInRight animate__duration-5s dbi" style="animation-delay: 0.1s;">
            <div class="tl f24 white he35 fl">上海谛视万象科技有限公司</div>
            <div class="ov  fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_3.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">联系电话：4007628008</span>
            </div>
          <!--  <div class="ov fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_1.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">地址：上海市普陀区真北路2653号天地科技园</span>
            </div>-->
          </li>
                   
        </ul>
      </div>
    </div>
    <!--底宣2end-->
    <!--底宣3-->
    <div class="he90 tc btto-c">
      <span class="dbi col-gr3  mt30 mr40">辽ICP备2025061615号</span> <span class="dbi col-gr3  mt30">Copyright © 2004 - 2025 谛视万象版权所有</span>
    </div>
    <!--底宣3end-->
  </div>

</template>
<script setup>

// watch onUpdated,
import { onMounted,  onUnmounted, ref } from 'vue';

import * as WOW from 'wowjs';
// let wowInstance = null;
const topMenuShow = ref(false)



// import * as dafultCss from '@/assets/css/default.css';
// import * as fontCss from '@/assets/css/font-awesome.min.css';
// import * as marginCss from '@/assets/css/margin.css';
// import * as mainCss from '@/assets/css/main.css';
// 捕获 ResizeObserver 警告，仅过滤特定提示
// const originalError = console.error;
// console.error = function (...args) {
//   // 匹配目标警告信息，避免过滤其他重要错误
//   if (args && args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed with undelivered notifications')) {
//     return; // 忽略该警告
//   }
//   originalError.apply(console, args); // 其他错误正常输出
// };

onMounted(() => {

  
/* dafultCss
fontCss
marginCss
mainCss */
// console.log('dafultCss',dafultCss)
// console.log('fontCss',fontCss)
// console.log('marginCss',marginCss)
// console.log('mainCss',mainCss)
  // console.log('初始化页面')
  window.scrollTo(0, 0);

  // // 方法2：使用对象参数（支持平滑滚动，IE11+）
  // window.scrollTo({
  //   top: 0,
  //   behavior: 'smooth' // 平滑滚动，可选值：'smooth' | 'auto'
  // });
  // 初始化值
  // window.scrollY = 0
  scrollTop.value = window.scrollY;

  topMenuShow.value = false
  showChangeDp();

  // 添加事件监听器
  window.addEventListener('scroll', handleScroll);
  new WOW.WOW({
    // boxClass: 'wow',
    animateClass: 'animate__animated',
    offset: 50,       // 元素进入视口 100px 后触发
    // mobile: true,      // 移动端启用
    live: true,        // 监听动态添加的元素
  }).init();

  // 循环播放
  show_loop()
});

// onUpdated(() => {
//   console.log('wowInstance', wowInstance)
// })
// let styleLink;
// let styleLink1;
// let styleLink2;
// let styleLink3;
// // let styleLink4;
// onMounted(() => {
//   // @import '@/assets/css/default.css';
//   // @import '@/assets/css/font-awesome.min.css';
//   // @import '@/assets/css/margin.css';
//   // @import '@/assets/css/main.css';


//   console.log('按需加载')
//   styleLink = document.createElement('link');
//   styleLink.href = '@/assets/css/default.css'; // 指向public中的a.css
//   styleLink.rel = 'stylesheet';
//   document.head.appendChild(styleLink);

//   styleLink1 = document.createElement('link');
//   styleLink1.href = '@/assets/css/font-awesome.min.css'; // 指向public中的a.css
//   styleLink1.rel = 'stylesheet';
//   document.head.appendChild(styleLink1);

//   styleLink2 = document.createElement('link');
//   styleLink2.href = '@/assets/css/margin.css'; // 指向public中的a.css
//   styleLink2.rel = 'stylesheet';
//   document.head.appendChild(styleLink2);

//   styleLink3 = document.createElement('link');
//   styleLink3.href = '@/assets/css/main.css'; // 指向public中的a.css
//   styleLink3.rel = 'stylesheet';
//   document.head.appendChild(styleLink3);


//   // document.head.appendChild(styleLink);
// });
// onUnmounted(() => {
//   if (styleLink) styleLink.remove(); // 组件卸载时移除样式
// });

onUnmounted(() => {
  // 移除事件监听器，防止内存泄漏
  window.removeEventListener('scroll', handleScroll);
});
function show_loop() {
}
const mouseenterCheck = ref(0)
function mouseenterFunc(num) {
  mouseenterCheck.value = num
}

// 跟踪窗口宽度和滚动位置
const scrollTop = ref(window.scrollY);
// const shouldApplyEffects = ref(false);


const showState = ref('top')
const showStateNum = ref(1)
// 更新滚动位置
const handleScroll = () => {
  // window.innerHeight
  let innerHeightThis = 100
  // console.log('[handleScroll]-[innerHeightThis:'+innerHeightThis+']-[window.scrollY:'+window.scrollY+']')
  if (window.scrollY <= innerHeightThis && (window.scrollY > scrollTop.value)) {
    if(showState.value != 'buttom'){
      showStateNum.value = 2
      // scrollToRef()
    }
    scrollTop.value = window.scrollY;
    topMenuShow.value = true
    showState.value = 'buttom'
  }

  if (window.scrollY <= innerHeightThis && (window.scrollY < scrollTop.value)) {
    showStateNum.value = 1
    // scrollToTopRef()
    scrollTop.value = window.scrollY;
    topMenuShow.value = false
    showState.value = 'top'
  }

};
// 计算是否应该应用效果
// const updateEffects = () => {
//   shouldApplyEffects.value =  scrollTop.value >= 1;
// };
// 监听窗口宽度和滚动位置变化
// watch([ scrollTop], updateEffects);

const targetRef = ref(null);
const targetTopRef = ref(null)
// const targetElement = ref(null)

// const scrollToRef = () => {
//   if (targetRef.value) {
//     targetRef.value.scrollIntoView({
//       behavior: 'smooth',
//       block: 'start' // 可选：'start', 'center', 'end', 'nearest'
//     });
//   }
// };

// const scrollToTopRef = () => {
//   if (targetTopRef.value) {
//     targetTopRef.value.scrollIntoView({
//       behavior: 'smooth',
//       block: 'start' // 可选：'start', 'center', 'end', 'nearest'
//     });
//   }
// };




const showChangeDpCheck = ref(1)
// 大屏播放效果
function showChangeDp() {

  setTimeout(() => {
    loopShowFunc()
    showChangeDp()
  }, 4000);
}

function loopShowFunc() {
  if (showChangeDpCheck.value < 6) {
    showChangeDpCheck.value = showChangeDpCheck.value + 1
  }
  else {
    showChangeDpCheck.value = 1
  }
}

function addAndDelFunc(typeState) {
  if (typeState == 'add') {
    // showChangeDpCheck.value
    if (showChangeDpCheck.value < 6) {
      showChangeDpCheck.value = showChangeDpCheck.value + 1
    }
    else {
      showChangeDpCheck.value = 1
    }
  }
  if (typeState == 'del') {
    if (showChangeDpCheck.value != 1) {
      showChangeDpCheck.value = showChangeDpCheck.value - 1
    }
    else {
      showChangeDpCheck.value = 6
    }
  }
}

function checkMunFunc(checkNum) {
  showChangeDpCheck.value = checkNum
}

const beforeEnter = (el) => {
  el.style.opacity = 0;
  el.style.transform = 'translateY(-20px)';
};
const enter = (el, done) => {
  requestAnimationFrame(() => {
    el.style.transition = 'opacity 0.5s ease, transform 0.3s ease';
    el.style.opacity = 1;
    el.style.transform = 'translateY(0)';
    done(); // 动画完成后调用
  });
};

const leave = (el, done) => {
  el.style.transition = 'opacity 0.5s ease, transform 0.3s ease';
  el.style.opacity = 0;
  el.style.transform = 'translateY(-20px)';
  setTimeout(done, 300);
};


</script>
<!-- module  -->
<!-- <style module></style> -->

<style scoped >
/* @import '@/assets/css/default.css' ;

:deep(){
  
} */

/* dafultCss
fontCss
marginCss
mainCss */
/* @import '@/assets/css/default.css';
@import '@/assets/css/font-awesome.min.css';
@import '@/assets/css/margin.css';
@import '@/assets/css/main.css'; */
/* @import 'animate.css'; */
/* dafultCss */
/* center center no-repeat */
.backImg1 {
  background: url(../assets/images/bana-1.jpg);
  /* background-size: contain; */
}

.backImg2 {
  background: url(../assets/images/bana-2.jpg) center center no-repeat;
  /* background-size: contain; */
}

.backImg3 {
  background: url(../assets/images/bana-3.jpg) center center no-repeat;
  /* background-size: contain; */
}

.backImg4 {
  background: url(../assets/images/bana-4.jpg) center center no-repeat;
  /* background-size: contain; */
}
.backImg5 {
  background: url(../assets/images/bana-14.jpg) center center no-repeat;
  /* background-size: contain; */
}
.backImg6 {
  background: url(../assets/images/bana-15.jpg) center center no-repeat;
  /* background-size: contain; */
}
.backy-b-1 {
  background: url(../assets/images/y-b-1.jpg) center no-repeat;
}

.backy-b-2 {
  background: url(../assets/images/y-b-2.jpg) center no-repeat;
}

.backy-b-3 {
  background: url(../assets/images/y-b-3.jpg) center no-repeat;
}

.backy-b-4 {
  background: url(../assets/images/y-b-4.jpg) center no-repeat;
}

.backy-b-5 {
  background: url(../assets/images/y-b-5.jpg) center no-repeat;
}

.animate__animated {
  animation-duration: 2s !important;
}

@layer utilities {
  .content-auto {
    content-visibility: auto;
  }

  .bg-zoom-container {
    overflow: hidden;
    position: relative;
    height: 100vh;
    width: 100%;
  }

  .bg-animated {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    animation: zoomIn 15s infinite alternate ease-in-out;
  }
}

@keyframes zoomIn {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.5);
  }
}

.pz_banner1{
  height: 100vh;
}

.pz_banner2{
  height: 0;
}

</style>
